import { AppLayout } from "../../components/layout/Header";
import ClientAccessPanel from "../../components/client/ClientAccessPanel";

export default function ClientAccessPage() {
  return (
    <AppLayout variant="public">
      <article className="legal-page">
        <h1>Client Access</h1>
        <p className="page-lead">
          Use the Client ID your advisor gave you. You will only see your buyer or seller portal.
        </p>
        <ClientAccessPanel />
      </article>
    </AppLayout>
  );
}
